import { render, staticRenderFns } from "./FilterHistoryOptions.vue?vue&type=template&id=5221b12c&"
import script from "./FilterHistoryOptions.vue?vue&type=script&lang=js&"
export * from "./FilterHistoryOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports